import React, { useState } from 'react'
import { useAuthStore } from '../stores/authStore'

export default function DevAuthHelper() {
  const [isVisible, setIsVisible] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { isAuthenticated, user, token, refreshToken } = useAuthStore()

  // Only show in development
  const isDevelopment = (import.meta as any).env?.VITE_NODE_ENV === 'development' || 
                       (import.meta as any).env?.DEV || 
                       window.location.hostname === 'localhost'

  if (!isDevelopment) {
    return null
  }

  const handleGetDevToken = async () => {
    setIsLoading(true)
    try {
      await refreshToken()
      console.log('✅ Development token refresh completed')
    } catch (error) {
      console.error('❌ Development token refresh failed:', error)
    } finally {
      setIsLoading(false)
    }
  }

  const handleTestAPI = async () => {
    try {
      const response = await fetch('/api/admin/dashboard/stats', {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })
      
      if (response.ok) {
        const data = await response.json()
        console.log('✅ API Test successful:', data)
        alert('API test successful! Check console for data.')
      } else {
        console.error('❌ API Test failed:', response.status, response.statusText)
        alert(`API test failed: ${response.status} ${response.statusText}`)
      }
    } catch (error) {
      console.error('❌ API Test error:', error)
      alert(`API test error: ${error}`)
    }
  }

  return (
    <div className="fixed bottom-4 right-4 z-50">
      <button
        onClick={() => setIsVisible(!isVisible)}
        className="bg-blue-600 text-white px-3 py-2 rounded-lg text-sm font-medium shadow-lg hover:bg-blue-700"
      >
        🔧 Dev Auth
      </button>
      
      {isVisible && (
        <div className="absolute bottom-12 right-0 bg-white border border-gray-200 rounded-lg shadow-xl p-4 w-80">
          <div className="space-y-3">
            <div className="text-sm font-medium text-gray-900">Development Auth Helper</div>
            
            <div className="space-y-2 text-xs">
              <div className="flex justify-between">
                <span className="text-gray-500">Authenticated:</span>
                <span className={isAuthenticated ? 'text-green-600' : 'text-red-600'}>
                  {isAuthenticated ? 'Yes' : 'No'}
                </span>
              </div>
              
              <div className="flex justify-between">
                <span className="text-gray-500">User:</span>
                <span className="text-gray-900 truncate max-w-32">
                  {user?.email || 'None'}
                </span>
              </div>
              
              <div className="flex justify-between">
                <span className="text-gray-500">Token:</span>
                <span className="text-gray-900 text-xs">
                  {token ? `${token.substring(0, 15)}...` : 'None'}
                </span>
              </div>
              
              <div className="flex justify-between">
                <span className="text-gray-500">LocalStorage:</span>
                <span className="text-gray-900">
                  {localStorage.getItem('admin_auth_token') ? 'Present' : 'Missing'}
                </span>
              </div>
            </div>
            
            <div className="space-y-2">
              <button
                onClick={handleGetDevToken}
                disabled={isLoading}
                className="w-full bg-green-600 text-white px-3 py-2 rounded text-sm hover:bg-green-700 disabled:opacity-50"
              >
                {isLoading ? 'Getting Token...' : 'Get Dev Token'}
              </button>
              
              <button
                onClick={handleTestAPI}
                disabled={!token}
                className="w-full bg-purple-600 text-white px-3 py-2 rounded text-sm hover:bg-purple-700 disabled:opacity-50"
              >
                Test API Call
              </button>
            </div>
            
            <div className="text-xs text-gray-500 border-t pt-2">
              This helper is only visible in development mode.
            </div>
          </div>
        </div>
      )}
    </div>
  )
}